import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Navbar";
import LeadCTA from "@/components/LeadCTA";

export default function Footer() {
  return (
    <footer className="border-t border-rule bg-white mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-4 text-ink/60 max-w-md leading-relaxed text-sm">
            AI tools that grow your Amazon business — free.
            Built by sellers, for sellers who can't afford the $400/mo tools.
          </p>
          <div className="mt-6">
            <LeadCTA sourcePage="footer" />
          </div>
        </div>
        <FooterCol title="Product">
          <FooterLink to="/tools/catalog-analyzer">Catalog Analyzer</FooterLink>
          <FooterLink to="/tools/listing-optimizer">Listing Optimizer</FooterLink>
          <FooterLink to="/tools/keyword-generator">Keyword Generator</FooterLink>
          <FooterLink to="/waitlist">Waitlist</FooterLink>
        </FooterCol>
        <FooterCol title="Reading">
          <FooterLink to="/blog">Journal</FooterLink>
        </FooterCol>
        <FooterCol title="Account">
          <FooterLink to="/login">Log in</FooterLink>
          <FooterLink to="/signup">Sign up</FooterLink>
        </FooterCol>
      </div>
      <div className="border-t border-rule">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row justify-between gap-2 label-mono">
          <span>© {new Date().getFullYear()} CliqCommerce</span>
          <span>Built for sellers · v1.0</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, children }) {
  return (
    <div className="md:col-span-2">
      <div className="label-mono mb-4">{title}</div>
      <ul className="space-y-2.5 text-sm text-ink/70">{children}</ul>
    </div>
  );
}
function FooterLink({ to, children }) {
  return <li><Link to={to} className="hover:text-ink transition-colors">{children}</Link></li>;
}
